[
 {
  "id": "panel",
  "x": 56,
  "y": 366,
  "w": 829,
  "h": 999
 }
]